// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__7p8ck","author":"Table_author__1Kew2","authorImage":"Table_authorImage__3uvty","unreadRow":"Table_unreadRow__1NNWd"};